// // import React, { useState, useEffect, useCallback } from "react";
// // import axios from "axios";
// // import { FaWallet, FaHistory, FaPlusCircle, FaSyncAlt, FaTicketAlt } from "react-icons/fa";
// // import APIURL from "../../common/Config";
// // import "./Wallet.css";

// // const PRESETS = [10, 100, 200, 500, 1000, 1500, 2000, 2500, 3000];

// // const Wallet = () => {
// //     const [activeTab, setActiveTab] = useState("recharge");
// //     const [amount, setAmount] = useState("");
// //     const [balance, setBalance] = useState(0);
// //     const [freeSeconds, setFreeSeconds] = useState(0);
// //     const [loading, setLoading] = useState(false);
// //     const [promo, setPromo] = useState("");
// //     const [previewData, setPreviewData] = useState(null);
// //     const [transactions, setAllTx] = useState([]);
// //     const [isRefreshing, setIsRefreshing] = useState(false);

// //     // FIX 1: Storage se data nikalne ka robust tareeka (Sir ke code jaisa)
// //     const storedUserData = JSON.parse(localStorage.getItem("userData"));
// //     const customerId = storedUserData?.id || localStorage.getItem("customerId");
// //     const phoneNumber = localStorage.getItem("phoneNumber");

// //     const fetchBalance = useCallback(async () => {
// //         if (!customerId) return;
// //         try {
// //             const res = await axios.get(`${APIURL}/wallet/balance/${customerId}`);
// //             setBalance(res.data.walletBalance);
// //             setFreeSeconds(res.data.freeRemainingChatSeconds);
// //         } catch (err) {
// //             console.error("Balance error", err);
// //         }
// //     }, [customerId]);

// //     const fetchTransactions = useCallback(async () => {
// //         if (!customerId) return;
// //         setLoading(true);
// //         try {
// //             const res = await axios.get(`${APIURL}/api/payments/txn-history/${customerId}`);
// //             if (res.data?.status === "SUCCESS") {
// //                 setAllTx(res.data.data);
// //             }
// //         } catch (err) {
// //             console.error("Txn history error", err);
// //         } finally {
// //             setLoading(false);
// //         }
// //     }, [customerId]);

// //     // Preview logic exactly as per Sir's logic
// //     useEffect(() => {
// //         const getPreview = async () => {
// //             if (amount > 0 && customerId) {
// //                 try {
// //                     const res = await axios.post(`${APIURL}/wallet/preview`, {
// //                         customerId: Number(customerId),
// //                         amount: Number(amount),
// //                         paymentMethod: "UPI",
// //                         promoCode: promo.trim()
// //                     });
// //                     setPreviewData(res.data);
// //                 } catch (err) {
// //                     console.error("Preview error", err);
// //                 }
// //             }
// //         };
// //         const timer = setTimeout(getPreview, 500); // Debounce to avoid too many calls
// //         return () => clearTimeout(timer);
// //     }, [amount, promo, customerId]);

// //     useEffect(() => {
// //         fetchBalance();
// //         if (activeTab === "history") fetchTransactions();
// //     }, [activeTab, fetchBalance, fetchTransactions]);

// //     // FIX 2: Handle Recharge (Sir ke Initiate logic ke sath match kiya hai)
// //   const handleRecharge = async () => {
// //     if (!amount || amount <= 0) return alert("Please enter a valid amount");
// //     if (!customerId || !phoneNumber) return alert("User session expired. Please login again.");

// //     // CHECK: Kya Razorpay script loaded hai?
// //     if (!window.Razorpay) {
// //         alert("Razorpay SDK failed to load. Are you online?");
// //         return;
// //     }

// //     try {
// //         setLoading(true);
// //         // 1. INITIATE PAYMENT (Backend call)
// //         const initResp = await axios.post(`${APIURL}/api/payments/initiate`, {
// //             customerId: Number(customerId),
// //             amount: Number(amount),
// //             mobileNo: phoneNumber,
// //             paymentGatewayName: "RAZORPAY"
// //         });

// //         const initData = initResp.data;

// //         if (!initData?.merchantId || !initData?.razorpayOrderId) {
// //             throw new Error("Initialization failed from server");
// //         }

// //         // 2. Razorpay Options
// //         const options = {
// //             key: initData.merchantId,
// //             amount: Number(amount) * 100,
// //             currency: "INR",
// //             name: "AstroBhagya",
// //             description: "Wallet Recharge",
// //             image: "https://heastro.in/AB_LOGO.png",
// //             order_id: initData.razorpayOrderId,
// //             handler: async function (response) {
// //                 // 3. UPDATE TRANSACTION
// //                 try {
// //                     await axios.post(`${APIURL}/api/payments/razorpay/updatetrans`, {
// //                         paymentId: response.razorpay_payment_id,
// //                         orderid: response.razorpay_order_id,
// //                         signature: response.razorpay_signature,
// //                         transactionId: initData.transactionId,
// //                         customerId: Number(customerId),
// //                         amount: Number(amount),
// //                         status: "SUCCESS",
// //                         statusDescp: "Payment completed successfully"
// //                     });
// //                     alert("Recharge Successful!");
// //                     fetchBalance();
// //                     setActiveTab("history");
// //                 } catch (e) {
// //                     console.error("Update Trans Error", e);
// //                 }
// //             },
// //             prefill: {
// //                 name: initData.customerName || "",
// //                 contact: phoneNumber
// //             },
// //             theme: { color: "#89184a" }
// //         };

// //         const rzp = new window.Razorpay(options);
// //         rzp.open();
// //     } catch (err) {
// //         console.error("Payment error:", err);
// //         alert("Payment Initiation Failed. Please try again.");
// //     } finally {
// //         setLoading(false);
// //     }
// // };

// //     return (
// //         <div className="wallet-container">
// //             {/* Header section remains same */}
// //             <div className="wallet-header-card">
// //                 <div className="balance-info">
// //                     <p className="label">Your Balance</p>
// //                     <h1 className="balance-amt">₹ {balance} 
// //                         <FaSyncAlt 
// //                             className={`refresh-icon ${isRefreshing ? 'spin' : ''}`} 
// //                             onClick={() => { setIsRefreshing(true); fetchBalance().then(()=>setIsRefreshing(false)); }} 
// //                         />
// //                     </h1>
// //                 </div>
// //                 {/* <div className="free-credits-badge">
// //                     <FaTicketAlt />
// //                     <span>Free Credits: {freeSeconds} sec</span>
// //                 </div> */}
// //             </div>

// //             <div className="wallet-tabs">
// //                 <button className={activeTab === "recharge" ? "active" : ""} onClick={() => setActiveTab("recharge")}>
// //                     <FaPlusCircle /> Recharge
// //                 </button>
// //                 <button className={activeTab === "history" ? "active" : ""} onClick={() => setActiveTab("history")}>
// //                     <FaHistory /> History
// //                 </button>
// //             </div>

// //             {activeTab === "recharge" ? (
// //                 <div className="recharge-section">
// //                     <h3>Select Amount</h3>
// //                     <div className="presets-grid">
// //                         {PRESETS.map(amt => (
// //                             <div key={amt} className={`preset-item ${amount == amt ? "selected" : ""}`} onClick={() => setAmount(amt)}>
// //                                 ₹{amt}
// //                             </div>
// //                         ))}
// //                     </div>

// //                     <input type="number" placeholder="Enter custom amount" value={amount} onChange={(e) => setAmount(e.target.value)} className="amt-input" />

// //                     {/* <div className="promo-section">
// //                         <input type="text" placeholder="Promo Code" value={promo} onChange={(e) => setPromo(e.target.value.toUpperCase())} />
// //                         <button className="apply-btn">Apply</button>
// //                     </div> */}

// //                     {previewData && (
// //                         <div className="summary-box">
// //                             <div className="summary-row"><span>Amount</span> <span>₹{Number(amount).toFixed(2)}</span></div>
// //                             <div className="summary-row"><span>Processing Fee</span> <span>₹{previewData.processingFee || 0}</span></div>
// //                             <div className="summary-row discount"><span>Promo Discount</span> <span>-₹{previewData.promoDiscount || 0}</span></div>
// //                             <div className="summary-row total"><span>Total Payable</span> <span>₹{previewData.totalPayable || amount}</span></div>
// //                         </div>
// //                     )}

// //                     <button className="proceed-btn" onClick={handleRecharge} disabled={loading}>
// //                         {loading ? "Processing..." : "Proceed to Payment"}
// //                     </button>
// //                 </div>
// //             ) : (
// //                 <div className="history-section">
// //                     {loading ? <p>Loading history...</p> : 
// //                         transactions.length === 0 ? <p className="no-data">No transactions found</p> :
// //                         transactions.map(tx => (
// //                             <div key={tx.transactionId} className="tx-card">
// //                                 <div className="tx-info">
// //                                     <p className="tx-title">Paid To AstroBhagya</p>
// //                                     <p className="tx-id">TXN: {tx.transactionId}</p>
// //                                     <p className="tx-date">{new Date(tx.receiveTime).toLocaleString()}</p>
// //                                 </div>
// //                                 <div className="tx-status-amt">
// //                                     <p className={`status ${tx.status?.toLowerCase()}`}>{tx.status}</p>
// //                                     <p className=".amt-input">₹{tx.amount}</p>
// //                                 </div>
// //                             </div>
// //                         ))
// //                     }
// //                 </div>
// //             )}
// //             <Footer />
// //         </div>
// //     );
// // };

// // export default Wallet;
// import React, { useState, useEffect, useCallback } from "react";
// import axios from "axios";
// import { FaWallet, FaHistory, FaPlusCircle, FaSyncAlt } from "react-icons/fa";
// import APIURL from "../../common/Config";
// import Header from "../header/header"; // Apna sahi path check kar lena
// import Footer from "../footer/footer"; // Apna sahi path check kar lena
// import "./Wallet.css";

// const PRESETS = [10, 100, 200, 500, 1000, 1500, 2000, 2500, 3000];

// const Wallet = () => {
//     const [activeTab, setActiveTab] = useState("recharge");
//     const [amount, setAmount] = useState("");
//     const [balance, setBalance] = useState(0);
//     const [loading, setLoading] = useState(false);
//     const [promo, setPromo] = useState("");
//     const [previewData, setPreviewData] = useState(null);
//     const [transactions, setAllTx] = useState([]);
//     const [isRefreshing, setIsRefreshing] = useState(false);

//     const storedUserData = JSON.parse(localStorage.getItem("userData"));
//     const customerId = storedUserData?.id || localStorage.getItem("customerId");
//     const phoneNumber = localStorage.getItem("phoneNumber");

//     const fetchBalance = useCallback(async () => {
//         if (!customerId) return;
//         try {
//             const res = await axios.get(`${APIURL}/wallet/balance/${customerId}`);
//             setBalance(res.data.walletBalance);
//         } catch (err) {
//             console.error("Balance error", err);
//         }
//     }, [customerId]);

//     const fetchTransactions = useCallback(async () => {
//         if (!customerId) return;
//         setLoading(true);
//         try {
//             const res = await axios.get(`${APIURL}/api/payments/txn-history/${customerId}`);
//             if (res.data?.status === "SUCCESS") {
//                 setAllTx(res.data.data);
//             }
//         } catch (err) {
//             console.error("Txn history error", err);
//         } finally {
//             setLoading(false);
//         }
//     }, [customerId]);

//     useEffect(() => {
//         fetchBalance();
//         if (activeTab === "history") fetchTransactions();
//     }, [activeTab, fetchBalance, fetchTransactions]);

//     const handleRecharge = async () => {
//         if (!amount || amount <= 0) return alert("Please enter a valid amount");
//         if (!window.Razorpay) return alert("Razorpay SDK not loaded");

//         try {
//             setLoading(true);
//             const initResp = await axios.post(`${APIURL}/api/payments/initiate`, {
//                 customerId: Number(customerId),
//                 amount: Number(amount),
//                 mobileNo: phoneNumber,
//                 paymentGatewayName: "RAZORPAY"
//             });

//             const initData = initResp.data;
//             const options = {
//                 key: initData.merchantId,
//                 amount: Number(amount) * 100,
//                 currency: "INR",
//                 name: "AstroBhagya",
//                 order_id: initData.razorpayOrderId,
//                 handler: async function (response) {
//                     await axios.post(`${APIURL}/api/payments/razorpay/updatetrans`, {
//                         paymentId: response.razorpay_payment_id,
//                         orderid: response.razorpay_order_id,
//                         signature: response.razorpay_signature,
//                         transactionId: initData.transactionId,
//                         customerId: Number(customerId),
//                         amount: Number(amount),
//                         status: "SUCCESS",
//                         statusDescp: "Payment completed successfully"
//                     });
//                     alert("Recharge Successful!");
//                     fetchBalance();
//                     setActiveTab("history");
//                 },
//                 prefill: { contact: phoneNumber },
//                 theme: { color: "#89184a" }
//             };
//             new window.Razorpay(options).open();
//         } catch (err) {
//             alert("Payment Failed");
//         } finally {
//             setLoading(false);
//         }
//     };

//     return (
//         <div className="wallet-page-wrapper">
//             <Header />
            
//             <div className="wallet-container">
//                 <div className="wallet-header-card">
//                     <div className="balance-info">
//                         <p className="label">Your Balance</p>
//                         <h1 className="balance-amt">₹ {balance} 
//                             <FaSyncAlt 
//                                 className={`refresh-icon ${isRefreshing ? 'spin' : ''}`} 
//                                 onClick={() => { setIsRefreshing(true); fetchBalance().then(()=>setIsRefreshing(false)); }} 
//                             />
//                         </h1>
//                     </div>
//                 </div>

//                 <div className="wallet-tabs">
//                     <button className={activeTab === "recharge" ? "active" : ""} onClick={() => setActiveTab("recharge")}>
//                         <FaPlusCircle /> Recharge
//                     </button>
//                     <button className={activeTab === "history" ? "active" : ""} onClick={() => setActiveTab("history")}>
//                         <FaHistory /> History
//                     </button>
//                 </div>

//                 {activeTab === "recharge" ? (
//                     <div className="recharge-section">
//                         <h3>Select Amount</h3>
//                         <div className="presets-grid">
//                             {PRESETS.map(amt => (
//                                 <div key={amt} className={`preset-item ${amount == amt ? "selected" : ""}`} onClick={() => setAmount(amt)}>
//                                     ₹{amt}
//                                 </div>
//                             ))}
//                         </div>
//                         <input type="number" placeholder="Enter custom amount" value={amount} onChange={(e) => setAmount(e.target.value)} className="amt-input" />
//                         <button className="proceed-btn" onClick={handleRecharge} disabled={loading}>
//                             {loading ? "Processing..." : "Proceed to Payment"}
//                         </button>
//                     </div>
//                 ) : (
//                     <div className="history-section">
//                         {loading ? <p>Loading history...</p> : 
//                             transactions.length === 0 ? <p className="no-data">No transactions found</p> :
//                             transactions.map(tx => (
//                                 <div key={tx.transactionId} className="tx-card">
//                                     <div className="tx-info">
//                                         <p className="tx-title">Paid To AstroBhagya</p>
//                                         <p className="tx-id">TXN: {tx.transactionId}</p>
//                                         <p className="tx-date">{new Date(tx.receiveTime).toLocaleString()}</p>
//                                     </div>
//                                     <div className="tx-status-amt">
//                                         <p className={`status ${tx.status?.toLowerCase()}`}>{tx.status}</p>
//                                         {/* FIX: Amount color and visibility */}
//                                         <p className="tx-amount">₹{tx.amount}</p> 
//                                     </div>
//                                 </div>
//                             ))
//                         }
//                     </div>
//                 )}
//             </div>

//             <Footer />
//         </div>
//     );
// };

// export default Wallet;
// import React, { useState, useEffect, useCallback } from "react";
// import axios from "axios";
// import { FaHistory, FaPlusCircle, FaSyncAlt, FaTag, FaCheckCircle, FaTimesCircle } from "react-icons/fa";
// import APIURL from "../../common/Config";
// import Header from "../header/header";
// import Footer from "../footer/footer";
// import "./Wallet.css";

// const PRESETS = [10, 100, 200, 500, 1000, 1500, 2000, 2500, 3000];

// const UTILISED_PROMO_KEY = "UTILISED_PROMO";

// // ─── LocalStorage helpers (mirrors app's AsyncStorage logic) ─────────────────
// const setUtilisedPromoInStorage = (code) => {
//     try { localStorage.setItem(UTILISED_PROMO_KEY, code); } catch (e) {}
// };

// const validateIfPromoAlreadyUsed = (code) => {
//     try {
//         const used = localStorage.getItem(UTILISED_PROMO_KEY);
//         return used === code;
//     } catch (e) { return false; }
// };
// // ─────────────────────────────────────────────────────────────────────────────

// const Wallet = () => {
//     const [activeTab, setActiveTab]         = useState("recharge");
//     const [amount, setAmount]               = useState("");
//     const [balance, setBalance]             = useState(0);
//     const [loading, setLoading]             = useState(false);
//     const [isRefreshing, setIsRefreshing]   = useState(false);
//     const [transactions, setAllTx]          = useState([]);

//     // ── Promo states (exact mirror of app) ──────────────────────────────────
//     const [promo, setPromo]                 = useState("");
//     const [promoMessage, setPromoMessage]   = useState("");
//     const [promoStatus, setPromoStatus]     = useState("");   // "SUCCESS" | "ERROR" | ""
//     const [previewData, setPreviewData]     = useState(null);
//     const [submittedForCharging, setSubmittedForCharging] = useState(false);
//     // ────────────────────────────────────────────────────────────────────────

//     const storedUserData = JSON.parse(localStorage.getItem("userData") || "null");
//     const customerId  = storedUserData?.id || localStorage.getItem("customerId");
//     const phoneNumber = localStorage.getItem("phoneNumber");

//     // ── Balance ─────────────────────────────────────────────────────────────
//     const fetchBalance = useCallback(async () => {
//         if (!customerId) return;
//         try {
//             const res = await axios.get(`${APIURL}/wallet/balance/${customerId}`);
//             setBalance(res.data.walletBalance);
//         } catch (err) { console.error("Balance error", err); }
//     }, [customerId]);

//     // ── Transactions ────────────────────────────────────────────────────────
//     const fetchTransactions = useCallback(async () => {
//         if (!customerId) return;
//         setLoading(true);
//         try {
//             const res = await axios.get(`${APIURL}/api/payments/txn-history/${customerId}`);
//             if (res.data?.status === "SUCCESS") setAllTx(res.data.data);
//         } catch (err) { console.error("Txn history error", err); }
//         finally { setLoading(false); }
//     }, [customerId]);

//     useEffect(() => {
//         fetchBalance();
//         if (activeTab === "history") fetchTransactions();
//     }, [activeTab, fetchBalance, fetchTransactions]);

//     // ── Preview / Promo API  (100% same as app's callPreviewAPI) ────────────
//     const callPreviewAPI = async () => {
//         const amountNum = Number(amount);
//         if (!amountNum || amountNum <= 0 || !customerId) return null;

//         let normalizedPromo = promo.trim().toUpperCase();

//         // Check if promo already used (mirrors app logic)
//         if (normalizedPromo && validateIfPromoAlreadyUsed(normalizedPromo)) {
//             alert(`Promo Code ${normalizedPromo} already used. Cannot use it again.`);
//             setPromo("");
//             normalizedPromo = "";
//         }

//         try {
//             const body = {
//                 customerId: Number(customerId),
//                 amount: amountNum,
//                 paymentMethod: "UPI",
//                 promoCode: normalizedPromo,
//             };
//             const res = await axios.post(`${APIURL}/wallet/preview`, body, {
//                 headers: { "Content-Type": "application/json" },
//             });
//             setPreviewData(res.data);

//             // Handle promo status message (mirrors app)
//             const promoStatusMsg = res.data?.promoCodeStatus;
//             if (promoStatusMsg) {
//                 setPromoMessage(promoStatusMsg);
//                 setPromoStatus(
//                     promoStatusMsg.toLowerCase().includes("success") ? "SUCCESS" : "ERROR"
//                 );
//             } else {
//                 setPromoMessage("");
//                 setPromoStatus("");
//             }
//             return res.data;
//         } catch (err) {
//             console.error("Preview error", err);
//             alert("Failed to apply promo code. Please try again.");
//             return null;
//         }
//     };

//     // Auto-preview when amount changes (no promo) — same as app's useEffect
//     useEffect(() => {
//         const amountNum = Number(amount);
//         if (amountNum > 0) {
//             callPreviewAPI();
//         } else {
//             setPreviewData(null);
//         }
//         // Reset promo feedback when amount changes
//         setPromoMessage("");
//         setPromoStatus("");
//     }, [amount]);

//     // ── Reset state after success (mirrors app's resetRechargeState) ────────
//     const resetRechargeState = () => {
//         setAmount("");
//         setPromo("");
//         setPromoMessage("");
//         setPromoStatus("");
//         setPreviewData(null);
//         setSubmittedForCharging(false);
//         localStorage.removeItem(UTILISED_PROMO_KEY);
//     };

//     // ── Handle Recharge (mirrors app's sendRazorpayPayment exactly) ─────────
//     const handleRecharge = async () => {
//         const amountNum = Number(amount);

//         // Re-call preview to get fresh totalPayable (same as app)
//         let freshPreview = previewData;
//         if (amountNum > 0) {
//             freshPreview = await callPreviewAPI();
//         }

//         if (!amountNum || amountNum <= 0)
//             return alert("Please enter a valid amount");
//         if (!window.Razorpay)
//             return alert("Razorpay SDK not loaded. Please check your connection.");
//         if (!customerId || !phoneNumber)
//             return alert("User session expired. Please login again.");

//         const normalizedPromo = promo.trim().toUpperCase();

//         if (submittedForCharging) {
//             return alert("Payment request already submitted. Cannot submit duplicate request.");
//         }
//         if (normalizedPromo && validateIfPromoAlreadyUsed(normalizedPromo)) {
//             return alert(`Promo Code ${normalizedPromo} already used. Cannot use it again.`);
//         }

//         try {
//             setLoading(true);

//             // 1. INITIATE PAYMENT — includes promoCode & totalWalletCredit (same as app)
//             const initResp = await axios.post(`${APIURL}/api/payments/initiate`, {
//                 customerId: Number(customerId),
//                 amount: amountNum,
//                 mobileNo: phoneNumber,
//                 paymentGatewayName: "RAZORPAY",
//                 promoCode: normalizedPromo,
//                 totalWalletCredit: freshPreview?.totalWalletCredit || "",
//             }, { headers: { "Content-Type": "application/json" } });

//             const initData = initResp.data;
//             if (!initData?.merchantId || !initData?.razorpayOrderId)
//                 throw new Error("Payment initialization failed from server");

//             setSubmittedForCharging(true);

//             // 2. RAZORPAY OPTIONS — amount = totalPayable from preview (same as app)
//             const payableAmount = freshPreview?.totalPayable ?? amountNum;
//             const options = {
//                 key: initData.merchantId,
//                 amount: Number(payableAmount) * 100,   // paise
//                 currency: "INR",
//                 name: "AstroBhagya",
//                 description: "Wallet Recharge",
//                 image: "https://heastro.in/AB_LOGO.png",
//                 order_id: initData.razorpayOrderId,
//                 handler: async function (response) {
//                     // 3. SUCCESS — save promo usage, update transaction
//                     if (normalizedPromo.length > 2) {
//                         setUtilisedPromoInStorage(normalizedPromo);
//                     }
//                     try {
//                         await axios.post(`${APIURL}/api/payments/razorpay/updatetrans`, {
//                             paymentId: response.razorpay_payment_id,
//                             orderid: response.razorpay_order_id,
//                             signature: response.razorpay_signature,
//                             transactionId: initData.transactionId,
//                             customerId: Number(customerId),
//                             amount: Number(payableAmount),
//                             status: "SUCCESS",
//                             statusDescp: "Payment completed successfully",
//                             reqData: {
//                                 razorpayOptions: options,
//                                 razorpayResponse: response,
//                             },
//                         });
//                         alert("Recharge Successful! 🎉");
//                         fetchBalance();
//                         fetchTransactions();
//                         resetRechargeState();
//                         setActiveTab("history");
//                     } catch (e) {
//                         console.error("Update trans error", e);
//                     }
//                 },
//                 prefill: {
//                     name: initData.customerName || "",
//                     contact: phoneNumber,
//                 },
//                 notes: {
//                     customer_id: customerId,
//                     purpose: "AstroBhagya Consultancy Payment",
//                 },
//                 theme: { color: "#89184a" },
//                 modal: {
//                     ondismiss: async () => {
//                         // 4. FAILED / DISMISSED — update transaction (same as app)
//                         try {
//                             await axios.post(`${APIURL}/api/payments/razorpay/updatetrans`, {
//                                 paymentId: "",
//                                 orderid: initData.razorpayOrderId,
//                                 signature: "",
//                                 transactionId: initData.transactionId,
//                                 customerId: Number(customerId),
//                                 amount: Number(payableAmount),
//                                 status: "FAILED",
//                                 statusDescp: "Payment dismissed by user",
//                             });
//                         } catch (e) { console.error("Failed update error", e); }
//                         setSubmittedForCharging(false);
//                         setLoading(false);
//                     },
//                 },
//             };

//             new window.Razorpay(options).open();
//         } catch (err) {
//             console.error("Payment error:", err);
//             alert("Payment Initiation Failed. Please try again.");
//             setSubmittedForCharging(false);
//         } finally {
//             setLoading(false);
//         }
//     };

//     // ── Render ───────────────────────────────────────────────────────────────
//     return (
//         <div className="wallet-page-wrapper">
//             <Header />

//             <div className="wallet-container">

//                 {/* ── Balance Card ── */}
//                 <div className="wallet-header-card">
//                     <div className="balance-info">
//                         <p className="label">Your Balance</p>
//                         <h1 className="balance-amt">
//                             ₹ {balance}
//                             <FaSyncAlt
//                                 className={`refresh-icon ${isRefreshing ? "spin" : ""}`}
//                                 onClick={() => {
//                                     setIsRefreshing(true);
//                                     fetchBalance().then(() => setIsRefreshing(false));
//                                 }}
//                                 title="Refresh Balance"
//                             />
//                         </h1>
//                     </div>
//                 </div>

//                 {/* ── Tabs ── */}
//                 <div className="wallet-tabs">
//                     <button
//                         className={activeTab === "recharge" ? "active" : ""}
//                         onClick={() => setActiveTab("recharge")}
//                     >
//                         <FaPlusCircle /> Recharge
//                     </button>
//                     <button
//                         className={activeTab === "history" ? "active" : ""}
//                         onClick={() => setActiveTab("history")}
//                     >
//                         <FaHistory /> History
//                     </button>
//                 </div>

//                 {/* ── Recharge Tab ── */}
//                 {activeTab === "recharge" && (
//                     <div className="recharge-section">
//                         <h3 className="section-title">Select Amount</h3>
//                         <div className="presets-grid">
//                             {PRESETS.map((amt) => (
//                                 <div
//                                     key={amt}
//                                     className={`preset-item ${Number(amount) === amt ? "selected" : ""}`}
//                                     onClick={() => {
//                                         setAmount(String(amt));
//                                         setSubmittedForCharging(false);
//                                     }}
//                                 >
//                                     ₹{amt}
//                                 </div>
//                             ))}
//                         </div>

//                         <input
//                             type="number"
//                             placeholder="Enter custom amount"
//                             value={amount}
//                             onChange={(e) => {
//                                 setAmount(e.target.value);
//                                 setSubmittedForCharging(false);
//                             }}
//                             className="amt-input"
//                         />

//                         {/* ── Promo Code Section ── */}
//                         <div className="promo-wrapper">
//                             <label className="promo-label">
//                                 <FaTag /> Promo Code <span className="optional">(Optional)</span>
//                             </label>
//                             <div className="promo-row">
//                                 <input
//                                     type="text"
//                                     className="promo-input"
//                                     placeholder="Enter Promo Code"
//                                     value={promo.toUpperCase()}
//                                     onChange={(e) => {
//                                         setPromo(e.target.value);
//                                         setPromoMessage("");
//                                         setPromoStatus("");
//                                     }}
//                                 />
//                                 <button
//                                     className="apply-btn"
//                                     onClick={callPreviewAPI}
//                                     disabled={!promo.trim() || !amount}
//                                 >
//                                     Apply
//                                 </button>
//                             </div>

//                             {/* Promo status message — same color logic as app */}
//                             {promoMessage && (
//                                 <div className={`promo-msg ${promoStatus === "SUCCESS" ? "promo-success" : "promo-error"}`}>
//                                     {promoStatus === "SUCCESS"
//                                         ? <FaCheckCircle className="promo-icon" />
//                                         : <FaTimesCircle className="promo-icon" />
//                                     }
//                                     {promoMessage}
//                                 </div>
//                             )}
//                         </div>

//                         {/* ── Summary Box (shows once amount is entered) ── */}
//                         {previewData && (
//                             <div className="summary-box">
//                                 <div className="summary-row">
//                                     <span>Amount to Recharge</span>
//                                     <span>₹{Number(amount).toFixed(2)}</span>
//                                 </div>
//                                 <div className="summary-row discount">
//                                     <span>Promo Discount</span>
//                                     <span>-₹{previewData.promoDiscount || 0}</span>
//                                 </div>
//                                 <div className="summary-row bonus">
//                                     <span>Bonus Applied</span>
//                                     <span>+₹{previewData.promoBonus || 0}</span>
//                                 </div>
//                                 <div className="summary-row total">
//                                     <span>Total Payable</span>
//                                     <span>₹{previewData.totalPayable ?? Number(amount).toFixed(2)}</span>
//                                 </div>
//                             </div>
//                         )}

//                         <button
//                             className="proceed-btn"
//                             onClick={handleRecharge}
//                             disabled={loading || submittedForCharging || !amount || Number(amount) <= 0}
//                         >
//                             {loading ? "Processing..." : "Proceed to Payment"}
//                         </button>
//                     </div>
//                 )}

//                 {/* ── History Tab ── */}
//                 {activeTab === "history" && (
//                     <div className="history-section">
//                         {loading ? (
//                             <p className="loading-text">Loading history...</p>
//                         ) : transactions.length === 0 ? (
//                             <p className="no-data">No transactions found</p>
//                         ) : (
//                             transactions.map((tx) => (
//                                 <div key={tx.transactionId} className="tx-card">
//                                     <div className="tx-info">
//                                         <p className="tx-title">Paid To AstroBhagya</p>
//                                         <p className="tx-id">TXN: {tx.transactionId}</p>
//                                         <p className="tx-date">
//                                             {new Date(tx.receiveTime).toLocaleString()}
//                                         </p>
//                                         {tx.promoApplied && tx.promoCode && (
//                                             <p className="tx-promo">
//                                                 🎟️ Promo: <strong>{tx.promoCode}</strong>
//                                             </p>
//                                         )}
//                                     </div>
//                                     <div className="tx-status-amt">
//                                         <p className={`status ${tx.status?.toLowerCase()}`}>
//                                             {tx.status}
//                                         </p>
//                                         <p className="tx-amount">₹{tx.amount}</p>
//                                         {tx.previousBalance !== null && tx.newBalance !== null && (
//                                             <p className="tx-bal-change">
//                                                 ₹{tx.previousBalance?.toFixed(2)} → ₹{tx.newBalance?.toFixed(2)}
//                                             </p>
//                                         )}
//                                     </div>
//                                 </div>
//                             ))
//                         )}
//                     </div>
//                 )}
//             </div>

//             <Footer />
//         </div>
//     );
// };

// export default Wallet;


import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { FaHistory, FaPlusCircle, FaSyncAlt, FaTag, FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import APIURL from "../../common/Config";
import Header from "../header/header";
import Footer from "../footer/footer";
import "./Wallet.css";

const PRESETS = [10, 100, 200, 500, 1000, 1500, 2000, 2500, 3000];

const UTILISED_PROMO_KEY = "UTILISED_PROMO";

// ─── LocalStorage helpers (mirrors app's AsyncStorage logic) ─────────────────
const setUtilisedPromoInStorage = (code) => {
    try { localStorage.setItem(UTILISED_PROMO_KEY, code); } catch (e) {}
};

const validateIfPromoAlreadyUsed = (code) => {
    try {
        const used = localStorage.getItem(UTILISED_PROMO_KEY);
        return used === code;
    } catch (e) { return false; }
};
// ─────────────────────────────────────────────────────────────────────────────

const Wallet = () => {
    const [activeTab, setActiveTab]         = useState("recharge");
    const [amount, setAmount]               = useState("");
    const [balance, setBalance]             = useState(0);
    const [remainingCredit, setRemainingCredit] = useState(0);
    const [loading, setLoading]             = useState(false);
    const [isRefreshing, setIsRefreshing]   = useState(false);
    const [transactions, setAllTx]          = useState([]);

    // ── Promo states (exact mirror of app) ──────────────────────────────────
    const [promo, setPromo]                 = useState("");
    const [promoMessage, setPromoMessage]   = useState("");
    const [promoStatus, setPromoStatus]     = useState("");   // "SUCCESS" | "ERROR" | ""
    const [previewData, setPreviewData]     = useState(null);
    const [submittedForCharging, setSubmittedForCharging] = useState(false);
    // ────────────────────────────────────────────────────────────────────────

    const storedUserData = JSON.parse(localStorage.getItem("userData") || "null");
    const customerId  = storedUserData?.id || localStorage.getItem("customerId");
    const phoneNumber = localStorage.getItem("phoneNumber");

    // ── Balance ─────────────────────────────────────────────────────────────
    const fetchBalance = useCallback(async () => {
        if (!customerId) return;
        try {
            const res = await axios.get(`${APIURL}/wallet/balance/${customerId}`);
            setBalance(res.data.walletBalance);
            setRemainingCredit(res.data.freeRemainingChatSeconds);
        } catch (err) { console.error("Balance error", err); }
    }, [customerId]);

    // ── Transactions ────────────────────────────────────────────────────────
    const fetchTransactions = useCallback(async () => {
        if (!customerId) return;
        setLoading(true);
        try {
            const res = await axios.get(`${APIURL}/api/payments/txn-history/${customerId}`);
            if (res.data?.status === "SUCCESS") setAllTx(res.data.data);
        } catch (err) { console.error("Txn history error", err); }
        finally { setLoading(false); }
    }, [customerId]);

    useEffect(() => {
        fetchBalance();
        if (activeTab === "history") fetchTransactions();
    }, [activeTab, fetchBalance, fetchTransactions]);

    // ── Preview / Promo API  (100% same as app's callPreviewAPI) ────────────
    const callPreviewAPI = async () => {
        const amountNum = Number(amount);
        if (!amountNum || amountNum <= 0 || !customerId) return null;

        let normalizedPromo = promo.trim().toUpperCase();

        // Check if promo already used (mirrors app logic)
        if (normalizedPromo && validateIfPromoAlreadyUsed(normalizedPromo)) {
            alert(`Promo Code ${normalizedPromo} already used. Cannot use it again.`);
            setPromo("");
            normalizedPromo = "";
        }

        try {
            const body = {
                customerId: Number(customerId),
                amount: amountNum,
                paymentMethod: "UPI",
                promoCode: normalizedPromo,
            };
            const res = await axios.post(`${APIURL}/wallet/preview`, body, {
                headers: { "Content-Type": "application/json" },
            });
            setPreviewData(res.data);

            // Handle promo status message (mirrors app)
            const promoStatusMsg = res.data?.promoCodeStatus;
            if (promoStatusMsg) {
                setPromoMessage(promoStatusMsg);
                setPromoStatus(
                    promoStatusMsg.toLowerCase().includes("success") ? "SUCCESS" : "ERROR"
                );
            } else {
                setPromoMessage("");
                setPromoStatus("");
            }
            return res.data;
        } catch (err) {
            console.error("Preview error", err);
            alert("Failed to apply promo code. Please try again.");
            return null;
        }
    };

    // Auto-preview when amount changes (no promo) — same as app's useEffect
    useEffect(() => {
        const amountNum = Number(amount);
        if (amountNum > 0) {
            callPreviewAPI();
        } else {
            setPreviewData(null);
        }
        // Reset promo feedback when amount changes
        setPromoMessage("");
        setPromoStatus("");
    }, [amount]);

    // ── Reset state after success (mirrors app's resetRechargeState) ────────
    const resetRechargeState = () => {
        setAmount("");
        setPromo("");
        setPromoMessage("");
        setPromoStatus("");
        setPreviewData(null);
        setSubmittedForCharging(false);
        localStorage.removeItem(UTILISED_PROMO_KEY);
    };

    // ── Handle Recharge (mirrors app's sendRazorpayPayment exactly) ─────────
    const handleRecharge = async () => {
        const amountNum = Number(amount);

        // Re-call preview to get fresh totalPayable (same as app)
        let freshPreview = previewData;
        if (amountNum > 0) {
            freshPreview = await callPreviewAPI();
        }

        if (!amountNum || amountNum <= 0)
            return alert("Please enter a valid amount");
        if (!window.Razorpay)
            return alert("Razorpay SDK not loaded. Please check your connection.");
        if (!customerId || !phoneNumber)
            return alert("User session expired. Please login again.");

        const normalizedPromo = promo.trim().toUpperCase();

        if (submittedForCharging) {
            return alert("Payment request already submitted. Cannot submit duplicate request.");
        }
        if (normalizedPromo && validateIfPromoAlreadyUsed(normalizedPromo)) {
            return alert(`Promo Code ${normalizedPromo} already used. Cannot use it again.`);
        }

        try {
            setLoading(true);

            // payableAmount = totalPayable from preview (promo applied),
            // fallback to original amount if no preview
            const payableAmount = freshPreview?.totalPayable ?? amountNum;

            // 1. INITIATE PAYMENT — amount = totalPayable (promo-discounted), same as app
            const initResp = await axios.post(`${APIURL}/api/payments/initiate`, {
                customerId: Number(customerId),
                amount: Number(payableAmount),          // ← FIXED: totalPayable, not amountNum
                mobileNo: phoneNumber,
                paymentGatewayName: "RAZORPAY",
                promoCode: normalizedPromo,
                totalWalletCredit: freshPreview?.totalWalletCredit || "",
            }, { headers: { "Content-Type": "application/json" } });

            const initData = initResp.data;
            if (!initData?.merchantId || !initData?.razorpayOrderId)
                throw new Error("Payment initialization failed from server");

            setSubmittedForCharging(true);
            const options = {
                key: initData.merchantId,
                amount: Number(payableAmount) * 100,   // paise
                currency: "INR",
                name: "AstroBhagya",
                description: "Wallet Recharge",
                image: "https://heastro.in/AB_LOGO.png",
                order_id: initData.razorpayOrderId,
                handler: async function (response) {
                    // 3. SUCCESS — save promo usage, update transaction
                    if (normalizedPromo.length > 2) {
                        setUtilisedPromoInStorage(normalizedPromo);
                    }
                    try {
                        await axios.post(`${APIURL}/api/payments/razorpay/updatetrans`, {
                            paymentId: response.razorpay_payment_id,
                            orderid: response.razorpay_order_id,
                            signature: response.razorpay_signature,
                            transactionId: initData.transactionId,
                            customerId: Number(customerId),
                            amount: Number(payableAmount),
                            status: "SUCCESS",
                            statusDescp: "Payment completed successfully",
                            reqData: {
                                razorpayOptions: options,
                                razorpayResponse: response,
                            },
                        });
                        alert("Recharge Successful! 🎉");
                        fetchBalance();
                        fetchTransactions();
                        resetRechargeState();
                        setActiveTab("history");
                    } catch (e) {
                        console.error("Update trans error", e);
                    }
                },
                prefill: {
                    name: initData.customerName || "",
                    contact: phoneNumber,
                },
                notes: {
                    customer_id: customerId,
                    purpose: "AstroBhagya Consultancy Payment",
                },
                theme: { color: "#89184a" },
                modal: {
                    ondismiss: async () => {
                        // 4. FAILED / DISMISSED — update transaction (same as app)
                        try {
                            await axios.post(`${APIURL}/api/payments/razorpay/updatetrans`, {
                                paymentId: "",
                                orderid: initData.razorpayOrderId,
                                signature: "",
                                transactionId: initData.transactionId,
                                customerId: Number(customerId),
                                amount: Number(payableAmount),
                                status: "FAILED",
                                statusDescp: "Payment dismissed by user",
                            });
                        } catch (e) { console.error("Failed update error", e); }
                        setSubmittedForCharging(false);
                        setLoading(false);
                    },
                },
            };

            new window.Razorpay(options).open();
        } catch (err) {
            console.error("Payment error:", err);
            alert("Payment Initiation Failed. Please try again.");
            setSubmittedForCharging(false);
        } finally {
            setLoading(false);
        }
    };

    // ── Render ───────────────────────────────────────────────────────────────
    return (
        <div className="wallet-page-wrapper">
            <Header />

            <div className="wallet-container">

                {/* ── Balance Card ── */}
                <div className="wallet-header-card">
                    <div className="balance-info">
                        <p className="label">Your Balance</p>
                        <h1 className="balance-amt">
                            ₹ {balance}
                            <FaSyncAlt
                                className={`refresh-icon ${isRefreshing ? "spin" : ""}`}
                                onClick={() => {
                                    setIsRefreshing(true);
                                    fetchBalance().then(() => setIsRefreshing(false));
                                }}
                                title="Refresh Balance"
                            />
                        </h1>
                        <p>Free Credit Remaining: {remainingCredit}</p>

                    </div>
                </div>

                {/* ── Tabs ── */}
                <div className="wallet-tabs">
                    <button
                        className={activeTab === "recharge" ? "active" : ""}
                        onClick={() => setActiveTab("recharge")}
                    >
                        <FaPlusCircle /> Recharge
                    </button>
                    <button
                        className={activeTab === "history" ? "active" : ""}
                        onClick={() => setActiveTab("history")}
                    >
                        <FaHistory /> History
                    </button>
                </div>

                {/* ── Recharge Tab ── */}
                {activeTab === "recharge" && (
                    <div className="recharge-section">
                        <h3 className="section-title">Select Amount</h3>
                        <div className="presets-grid">
                            {PRESETS.map((amt) => (
                                <div
                                    key={amt}
                                    className={`preset-item ${Number(amount) === amt ? "selected" : ""}`}
                                    onClick={() => {
                                        setAmount(String(amt));
                                        setSubmittedForCharging(false);
                                    }}
                                >
                                    ₹{amt}
                                </div>
                            ))}
                        </div>

                        <input
                            type="number"
                            placeholder="Enter custom amount"
                            value={amount}
                            onChange={(e) => {
                                setAmount(e.target.value);
                                setSubmittedForCharging(false);
                            }}
                            className="amt-input"
                        />

                        {/* ── Promo Code Section ── */}
                        <div className="promo-wrapper">
                            <label className="promo-label">
                                <FaTag /> Promo Code <span className="optional">(Optional)</span>
                            </label>
                            <div className="promo-row">
                                <input
                                    type="text"
                                    className="promo-input"
                                    placeholder="Enter Promo Code"
                                    value={promo.toUpperCase()}
                                    onChange={(e) => {
                                        setPromo(e.target.value);
                                        setPromoMessage("");
                                        setPromoStatus("");
                                    }}
                                />
                                <button
                                    className="apply-btn"
                                    onClick={callPreviewAPI}
                                    disabled={!promo.trim() || !amount}
                                >
                                    Apply
                                </button>
                            </div>

                            {/* Promo status message — same color logic as app */}
                            {promoMessage && (
                                <div className={`promo-msg ${promoStatus === "SUCCESS" ? "promo-success" : "promo-error"}`}>
                                    {promoStatus === "SUCCESS"
                                        ? <FaCheckCircle className="promo-icon" />
                                        : <FaTimesCircle className="promo-icon" />
                                    }
                                    {promoMessage}
                                </div>
                            )}
                        </div>

                        {/* ── Summary Box (shows once amount is entered) ── */}
                        {previewData && (
                            <div className="summary-box">
                                <div className="summary-row">
                                    <span>Amount to Recharge</span>
                                    <span>₹{Number(amount).toFixed(2)}</span>
                                </div>
                                <div className="summary-row discount">
                                    <span>Promo Discount</span>
                                    <span>-₹{previewData.promoDiscount || 0}</span>
                                </div>
                                <div className="summary-row bonus">
                                    <span>Bonus Applied</span>
                                    <span>+₹{previewData.promoBonus || 0}</span>
                                </div>
                                <div className="summary-row total">
                                    <span>Total Payable</span>
                                    <span>₹{previewData.totalPayable ?? Number(amount).toFixed(2)}</span>
                                </div>
                            </div>
                        )}

                        <button
                            className="proceed-btn"
                            onClick={handleRecharge}
                            disabled={loading || submittedForCharging || !amount || Number(amount) <= 0}
                        >
                            {loading ? "Processing..." : "Proceed to Payment"}
                        </button>
                    </div>
                )}

                {/* ── History Tab ── */}
                {activeTab === "history" && (
                    <div className="history-section">
                        {loading ? (
                            <p className="loading-text">Loading history...</p>
                        ) : transactions.length === 0 ? (
                            <p className="no-data">No transactions found</p>
                        ) : (
                            transactions.map((tx) => (
                                <div key={tx.transactionId} className="tx-card">
                                    <div className="tx-info">
                                        <p className="tx-title">Paid To AstroBhagya</p>
                                        <p className="tx-id">TXN: {tx.transactionId}</p>
                                        <p className="tx-date">
                                            {new Date(tx.receiveTime).toLocaleString()}
                                        </p>
                                        {tx.promoApplied && tx.promoCode && (
                                            <p className="tx-promo">
                                                🎟️ Promo: <strong>{tx.promoCode}</strong>
                                            </p>
                                        )}
                                    </div>
                                    <div className="tx-status-amt">
                                        <p className={`status ${tx.status?.toLowerCase()}`}>
                                            {tx.status}
                                        </p>
                                        <p className="tx-amount">₹{tx.amount}</p>
                                        {tx.previousBalance !== null && tx.newBalance !== null && (
                                            <p className="tx-bal-change">
                                                ₹{tx.previousBalance?.toFixed(2)} → ₹{tx.newBalance?.toFixed(2)}
                                            </p>
                                        )}
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                )}
            </div>

            <Footer />
        </div>
    );
};

export default Wallet;
